/**
 * Formatador de tempo localizado para português brasileiro
 * Wrapper que traduz o resultado da função formatTime do @chatwoot/utils
 */

import { formatTime } from '@chatwoot/utils';

/**
 * @name formatTimePtBR
 * @description Wrapper que traduz o resultado do formatTime para português
 * @param timeInSeconds number - tempo em segundos
 * @returns string - tempo formatado em português
 */
export const formatTimePtBR = (timeInSeconds) => {
  if (!timeInSeconds || timeInSeconds < 0) {
    return '0 Seg';
  }

  // Usa a função original do @chatwoot/utils
  const formatted = formatTime(timeInSeconds);

  // Traduz as unidades de tempo para português
  // Nota: Usando replace com regex global para garantir que todas as ocorrências sejam substituídas
  return formatted
    .replace(/ Hr/g, ' H')
    .replace(/ Min/g, ' Min')
    .replace(/ Sec/g, ' Seg')
    .replace(/ Day/g, ' Dia');
};

/**
 * @name formatTimeShort
 * @description Formata tempo de forma abreviada (usado em gráficos)
 * @param timeInSeconds number - tempo em segundos
 * @returns string - tempo formatado de forma curta
 */
export const formatTimeShort = (timeInSeconds) => {
  if (!timeInSeconds) {
    return '';
  }

  if (timeInSeconds < 60) {
    return `${timeInSeconds}s`;
  }

  if (timeInSeconds < 3600) {
    const minutes = Math.floor(timeInSeconds / 60);
    return `${minutes}m`;
  }

  if (timeInSeconds < 86400) {
    const hours = Math.floor(timeInSeconds / 3600);
    return `${hours}h`;
  }

  const days = Math.floor(timeInSeconds / 86400);
  return `${days}d`;
};

// Exporta como default a função principal
export default formatTimePtBR;